<mat-toolbar class="header-toolbar">
  <mat-toolbar-row class="tw-flex tw-justify-between">
    <div class="header-toolbar_left-side tw-flex">
      <img class="logo tw-self-center" src="assets/core/images/bosch-logo.svg" />
      <hr class="divider divider--vertical" />
      <img
        *ngIf="showIntrackLogo"
        class="intrack-logo tw-self-center"
        src="/assets/core/images/intrack-logo_horizontal_light_gray.svg"
      />
      <ng-content></ng-content>
    </div>
    <div class="tw-flex" *ngIf="showLanguage">
      <mat-form-field class="language-select tw-self-center">
        <mat-select [formControl]="languageControl">
          <mat-option *ngFor="let language of languageList" [value]="language">
            {{ language | uppercase }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
